import { render, staticRenderFns } from "./FixedOrderPageDetail.vue?vue&type=template&id=402fa4e4"
import script from "./FixedOrderPageDetail.vue?vue&type=script&lang=js"
export * from "./FixedOrderPageDetail.vue?vue&type=script&lang=js"
import style0 from "./FixedOrderPageDetail.vue?vue&type=style&index=0&id=402fa4e4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports